<template>
    <div class="my-container">
        <!-- Card Principal Integrado -->
        <div class="my-card">
            <!-- Header do DataTable -->
            <div class="my-header">
                <div class="header-left">
                    <h1 class="datatable-title">Telemetria de Tanques</h1>
                    <span class="records-summary" v-if="hasTelemetry && loadedd">{{ tanksDataList.length }} tanque(s) monitorado(s)</span>
                    <span class="records-summary loading" v-else-if="loadedd">Serviço indisponível</span>
                    <span class="records-summary loading" v-else>Carregando...</span>
                </div>
                <div class="header-right" v-if="hasTelemetry && loadedd">
                    <button class="btn btn-secondary btn-action" :class="{ 'active': mode === 'card' }" @click="changeMode('card')">
                        <i class="fa fa-th-large"></i>
                        <span class="btn-text"> Cards</span>
                    </button>
                    <button class="btn btn-secondary btn-action" :class="{ 'active': mode === 'list' }" @click="changeMode('list')">
                        <i class="fa fa-list"></i>
                        <span class="btn-text"> Lista</span>
                    </button>
                </div>
            </div>

            <!-- Área de Conteúdo Unificada -->
            <div class="datatable-main-content">
                <!-- Loading State -->
                <div class="datatable-loading" v-if="!loadedd">
                    <div class="loading-overlay">
                        <div class="loading-spinner">
                            <div class="spinner"></div>
                        </div>
                        <div class="loading-text">
                            <h4>Carregando telemetria...</h4>
                            <p>Aguarde enquanto buscamos os dados dos tanques</p>
                        </div>
                    </div>
                </div>

                <!-- Conteúdo da Telemetria -->
                <div class="datatable-content" v-else-if="hasTelemetry">
                    <!-- Modo Cards -->
                    <div v-if="mode === 'card'" class="cards-view">
                        <div class="accordion">
                            <div class="accordion-item mb-3" v-for="(tanks, customerName, customerId) in groupedByCustomer" :key="customerId">
                                <h2 class="accordion-header" :id="'heading' + customerId">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            :data-bs-target="'#collapse' + customerId" aria-expanded="false"
                                            :aria-controls="'collapse' + customerId">
                                        {{ customerName }}
                                    </button>
                                </h2>
                                <div :id="'collapse' + customerId" class="accordion-collapse collapse"
                                     :aria-labelledby="'heading' + customerId">
                                    <div class="accordion-body row">
                                        <div class="col-lg-2 col-md-3 col-sm-5 coluna-custom" v-for="(card, index) in tanks" :key="'card' + index">
                                            <CardTank :value="card" :is-favorite="!!card.favorite"
                                                      @changeAlert="changeAlert"
                                                      @removeFavorite="removeFavorite" @addFavorite="addFavorite"
                                                      @viewDetails="viewDetails"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modo Lista -->
                    <div v-else class="table-view">
                        <div class="table-responsive">
                            <table class="datatable">
                                <thead class="my-header-row">
                                    <tr>                                        
                                        <th class="datatable-th">Tag Tanque</th>
                                        <th class="datatable-th">Produto</th>
                                        <th class="datatable-th">Nível/Capacidade</th>
                                        <th class="datatable-th">%</th>
                                        <th class="datatable-th">Status</th>
                                        <th class="datatable-th">Variação Abrupta</th>
                                        <th class="datatable-th">Data Atualização</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="datatable-row" v-for="(card, index) in tanksDataList" :key="'table-row' + index">
                                        <TableTank :value="card" :is-favorite="!!card.favorite"
                                                   @removeFavorite="removeFavorite"
                                                   @addFavorite="addFavorite"
                                                   @viewDetails="viewDetails"/>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Estado sem telemetria -->
                <div class="datatable-content" v-else>
                    <div class="empty-state">
                        <div class="empty-content">
                            <i class="fa fa-satellite-dish empty-icon"></i>
                            <h4>Serviço de Telemetria Indisponível</h4>
                            <div class="telemetry-info">
                                <h5>Olá {{ $store.getters.user.name }}!</h5>
                                <p>
                                    Você ainda não possui acesso ao serviço de telemetria da {{ env.applicationName || 'POTABILIS' }}.
                                    <br>
                                    Com esse módulo, você poderá monitorar em tempo real o nível dos tanques de seus produtos químicos,
                                    acompanhando pontos de recarga ou níveis críticos.
                                </p>
                                <p>
                                    Assim, será possível planejar o momento ideal para realizar
                                    novas compras, garantindo eficiência e evitando interrupções.
                                </p>
                                <p>
                                    Entre em contato com nosso time comercial para saber mais e contratar esse serviço.
                                </p>
<!--                                <button class="btn btn-primary btn-action" @click="$router.push('/admin/order-new')">-->
<!--                                    <i class="fa fa-phone mr-2"></i>-->
<!--                                    <span class="btn-text">Contatar Comercial</span>-->
<!--                                </button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal de Nível Crítico -->
    <div id="critical-level-modal">
        <div class="modal-fade-background"></div>
        <div :class="['modal fade show']" id="modal-pending" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-warning text-dark">
                        <h5 class="modal-title" id="criticalStockModalLabel">
                            <i class="bi bi-exclamation-triangle-fill"></i> Atenção
                        </h5>
                        <button type="button" @click="closeModal()" class="btn-close"></button>
                    </div>
                    <div class="modal-body text-center">
                        <p>
                            ⚠️ Alguns tanques estão com nível crítico!
                        </p>
                        <p>
                            Para evitar a interrupção no fornecimento, acesse a tela de pedidos e reponha seu estoque.
                            <br>
                            Caso não tenha contrato vigente para o produto, entre em contato com o comercial.
                        </p>

                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Tanque</th>
                                    <th>Produto</th>
                                    <th>Un. Medida</th>
                                    <th>Capacidade</th>
                                    <th>Nível Atual</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="tank in this.criticalTanks" :key="tank.tag">
                                    <td>{{ tank.tag }}</td>
                                    <td>{{ tank.content }}</td>
                                    <td>{{ tank.unit }}</td>
                                    <td>{{ tank.capacity }}</td>
                                    <td>{{ toBrNumber(tank.currentVolume) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-primary" @click="$router.push('/admin/order-new')">
                            Novo Pedido
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal de Detalhes do Tanque -->
    <TankDetailsModal 
        v-model="showTankDetailsModal" 
        :tank="selectedTank" 
    />
</template>

<script>
import CardTank from "./CardTank.vue";
import TanksData from './Models/TankModel';
import {ref, onMounted} from "vue";
import env from "@/env";
import {useStore} from "vuex";
import TableTank from "@/components/Telemetry/TableTank.vue";
import TankDetailsModal from "./TankDetailsModal.vue";
import TankModel from "./Models/TankModel";
import {floatToDecimal} from "./Dependencies/functions";

export default {
    page: {
        title: "Dashboard",
    },
    components: {
        TableTank,
        CardTank,
        TankDetailsModal,
    }, data() {
        return {
            loadedd: false,
            hasTelemetry: false,
            mode: "card",
            groupedByCustomer: {},
            tanksDataList: [],
            hasTankInCriticalLevel: false,
            showTankDetailsModal: false,
            selectedTank: null,
            env: env,
        };
    },
    computed: {
        criticalTanks() {
            return this.tanksDataList.filter(item => item.critical)
        }
    },
    methods: {
        toBrNumber(value) {
            if (value == 0) {
                return value
            } else if (value && parseFloat(value) !== 'NaN') {
                const convert = new Intl.NumberFormat('pt-BR', {style: 'decimal', minimumFractionDigits: 2});

                return convert.format(value.toFixed(2));
            } else {
                return '';
            }
        },
        closeModal() {
            close_modal("critical-level-modal")
        },
        async getTanqueApi() {
            try {
                let self = this
                const token = localStorage.getItem("token");
                if (!token) throw new Error("Token não encontrado!");

                const headers = new Headers({
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                });

                // Todo: alterar o customer_id
                const customer_id = this.store.getters.user.customer_id;                
                
                const response = await fetch(`${env.api}tanques?customer_id=${customer_id}`, {
                    method: "GET",
                    headers,
                });

                if (response.status !== 200) {
                    throw new Error(`Erro na API: ${response.statusText}`);
                }

                const json = await response.json();

                if (!Array.isArray(json)) {
                    throw new Error("A API não retornou um array de dados.");
                }

                const tanks = json.map((item) => new TankModel(item));
                this.tanksDataList = tanks;

                this.tanksDataList.forEach(tank => {
                    if (tank.criticalLevel > tank.currentVolume) {
                        this.hasTankInCriticalLevel = true
                        tank.critical = true

                        // aguarda antes de abrir o modal
                        window.setTimeout(function () {
                            show_modal("critical-level-modal");
                        }, 2000)
                    }
                });

                // show_modal("critical-level-modal");

                if (tanks.length > 0) {
                    this.hasTelemetry = true;
                }

                this.groupedByCustomer = tanks.reduce((groups, tank) => {
                    const {customerName} = tank;
                    if (!groups[customerName]) {
                        groups[customerName] = [];
                    }
                    groups[customerName].push(tank);

                    return groups;
                }, {});
            } catch (error) {
                console.error("Erro ao buscar tanques:", error.message);
            } finally {
                this.loadedd = true;
            }
        },
        changeMode(newMode) {
            this.mode = newMode;
        },
        viewDetails(tank) {
            this.selectedTank = tank;
            this.showTankDetailsModal = true;
        },
        addFavorite(tank) {
            // Implementar lógica para adicionar favorito
            tank.favorite = true;
            console.log('Adicionado aos favoritos:', tank.tag);
        },
        removeFavorite(tank) {
            // Implementar lógica para remover favorito
            tank.favorite = false;
            console.log('Removido dos favoritos:', tank.tag);
        },
        changeAlert(tank, hasAlert) {
            // Implementar lógica para alterar alerta
            tank.hasAlert = hasAlert;
            console.log('Alerta alterado:', tank.tag, hasAlert);
        },
    },
    mounted() {
        this.store = useStore(); // Inicializa o Vuex store
        this.getTanqueApi();
    },
}

</script>
<style>
.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-body p {
    margin-bottom: 10px;
    font-size: 1rem;
    line-height: 1.5;
}

.modal-footer {
    padding-top: 0;
}

.accordion-header {
    border-style: solid;
    border-color: lightgray;
    border-width: 0.1rem;
}

@media (max-width: 767px) {

    /* Tela pequena */
    .coluna-custom {
    }
}

@media (min-width: 768px) and (max-width: 991px) {

    /* Tela média */
    .coluna-custom {
        min-width: 220px;
    }
}

@media (min-width: 992px) {

    /* Tela grande */
    .coluna-custom {
        min-width: 220px;
    }
}

/* Estilos modernos baseados no BaseTable.vue */

/* DataTable Container */
.my-container {
    padding: 0;
    background: transparent;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

/* Card Principal */
.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    min-height: 500px;
    display: flex;
    flex-direction: column;
}

/* Header do DataTable */
.my-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: 1px solid #e9ecef;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.datatable-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: white;
}

.records-summary {
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.records-summary.loading {
    background: rgba(255, 255, 255, 0.1);
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
}

.header-right {
    display: flex;
    gap: 8px;
}

/* Container Principal Unificado */
.datatable-main-content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    overflow-x: auto;
    max-width: 100%;
    position: relative;
}

/* Loading State */
.datatable-loading {
    padding: 60px 24px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    min-height: inherit;
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 400px;
}

.loading-spinner .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text h4 {
    font-size: 18px;
    color: #495057;
    margin: 0 0 8px 0;
}

.loading-text p {
    color: #6c757d;
    margin: 0;
}

/* Conteúdo da Telemetria */
.datatable-content {
    background: white;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: inherit;
    padding: 20px 24px;
}

/* Botões de ação */
.btn-action {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
}

.btn-primary {
    background: #667eea;
    color: white;
}

.btn-primary:hover {
    background: #5a6fd8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background: #5a6268;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.btn-secondary.active {
    background: #495057;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-text {
    font-size: 13px;
}

/* Accordion moderno */
.accordion-item {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-bottom: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.accordion-button {
    background: #f8f9fa;
    border: none;
    font-weight: 600;
    color: #495057;
    padding: 16px 20px;
    transition: all 0.3s ease;
}

.accordion-button:focus {
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
    border-color: #667eea;
}

.accordion-button:not(.collapsed) {
    background: #667eea;
    color: white;
}

.accordion-body {
    padding: 20px;
    background: white;
}

/* Tabela */
.table-responsive {
    overflow-x: auto;
    max-width: 100%;
    box-sizing: border-box;
    flex: 1;
    min-height: 300px;
    display: flex;
    flex-direction: column;
}

.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    background: white;
    table-layout: auto;
}

.my-header-row {
    background: #f8f9fa;
}

.datatable-th {
    padding: 12px 16px;
    text-align: center;
    font-weight: 600;
    color: #495057;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e9ecef;
    background: #f8f9fa;
    white-space: nowrap;
}

.datatable-row {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f3f4;
}

.datatable-row:hover {
    background: #f8f9fa;
}

/* Estado Vazio */
.empty-state {
    padding: 60px 20px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-width: 500px;
}

.empty-icon {
    font-size: 48px;
    color: #adb5bd;
}

.empty-content h4 {
    font-size: 18px;
    color: #495057;
    margin: 0;
}

.telemetry-info h5 {
    color: #495057;
    font-weight: 600;
    margin-bottom: 16px;
}

.telemetry-info p {
    color: #6c757d;
    line-height: 1.6;
    margin-bottom: 12px;
    text-align: left;
}

/* Modal moderno */
.modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.modal-header {
    background: #ffc107;
    border-bottom: none;
    border-radius: 12px 12px 0 0;
}

.modal-body {
    padding: 24px;
}

.modal-footer {
    border-top: none;
    padding: 16px 24px;
}

/* Responsividade */
@media (max-width: 768px) {
    .my-container {
        padding: 0;
    }

    .my-header {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        padding: 16px;
    }

    .header-left {
        width: 100%;
    }

    .datatable-content {
        padding: 16px;
    }

    .btn-text {
        display: none;
    }

    .accordion-button {
        padding: 12px 16px;
        font-size: 14px;
    }

    .datatable-th {
        padding: 12px;
        font-size: 12px;
    }

    .empty-state {
        padding: 40px 16px;
        min-height: 300px;
    }

    .my-card {
        min-height: 400px;
    }

    .btn-action {
        padding: 6px 10px;
        font-size: 12px;
    }
}
</style>
